import { Loader2Icon } from 'lucide-react';
import { cn } from '#ui/lib/cn';

export type LoadingStateProps = {
  /** What is loading, read out to assistive tech and shown next to the spinner. */
  label?: string;
  className?: string;
};

/** The one loading state: every async view shows this while it waits. */
export function LoadingState({
  label = 'Loading…',
  className,
}: LoadingStateProps) {
  return (
    <output
      className={cn(
        'flex w-full flex-1 items-center justify-center gap-2 p-6 text-sm text-muted-foreground',
        className,
      )}
    >
      <Loader2Icon className="size-4 animate-spin" />
      {label}
    </output>
  );
}
